// Fonte única do estado de uma mensagem no relatório: rótulo em pt-br, tom de
// cor, faixa de severidade e — o que mais importa — se aquilo conta como falha.
//
// Antes isto vivia num ternário aninhado dentro da linha da lista. Passou a ser
// função pura porque o resumo de falhas precisa da MESMA regra: se as duas
// implementações divergirem, a barra volta a chamar de falha uma mensagem que foi
// entregue, que é exatamente o chamado que a correção do I007 fechou.

// O ack vem do WhatsApp e nunca é rebaixado; o status é reescrito toda vez que o
// documento passa pelo motor de envio. Quando os dois se contradizem, quem manda
// é o ack: ack >= 2 significa que o aparelho do destinatário recebeu.
const ACK_ENTREGUE = 2

const NAO_IDENTIFICADO = {
  rotulo: 'Não identificado',
  tom: 'neutro',
  severidade: null,
  entregueApesarDoErro: false,
  ehFalha: false,
}

export function getMessageStatus(message) {
  if (!message) return { ...NAO_IDENTIFICADO }

  const status = message.status
  const ack = Number(message.ack) || 0
  const entregueApesarDoErro = status === 'erro' && ack >= ACK_ENTREGUE

  if (entregueApesarDoErro) {
    return {
      rotulo: ack >= 3 ? 'Lida' : 'Entregue',
      tom: 'ok',
      severidade: null,
      entregueApesarDoErro: true,
      ehFalha: false,
    }
  }

  if (status === 'erro') {
    return {
      rotulo: 'Falhou',
      tom: 'erro',
      severidade: 'erro',
      entregueApesarDoErro: false,
      ehFalha: true,
    }
  }

  if (status === 'success') {
    if (ack >= 3) return { rotulo: 'Lida', tom: 'ok', severidade: null, entregueApesarDoErro: false, ehFalha: false }
    if (ack >= 2) return { rotulo: 'Entregue', tom: 'ok', severidade: null, entregueApesarDoErro: false, ehFalha: false }
    if (ack >= 1) return { rotulo: 'No servidor', tom: 'neutro', severidade: null, entregueApesarDoErro: false, ehFalha: false }
    return { rotulo: 'Enviada', tom: 'neutro', severidade: null, entregueApesarDoErro: false, ehFalha: false }
  }

  if (status === 'queue') {
    return { rotulo: 'Em fila', tom: 'espera', severidade: null, entregueApesarDoErro: false, ehFalha: false }
  }

  if (status === 'antiban_delayed') {
    return { rotulo: 'Adiada', tom: 'espera', severidade: 'espera', entregueApesarDoErro: false, ehFalha: false }
  }

  // Retida por saldo (bloqueio por saldo negativo da linha de crédito). Não é
  // falha: sai sozinha quando o cliente recarrega, dentro da validade.
  if (status === 'saldo_insuficiente') {
    return { rotulo: 'Saldo insuficiente', tom: 'espera', severidade: 'espera', entregueApesarDoErro: false, ehFalha: false }
  }

  // Link de pagamento fora do ar: o servidor tenta de novo sozinho (até 24h).
  // Não é falha — antes da retenção ela ia pra Meta sem o link e voltava erro.
  if (status === 'hiperpay_delayed') {
    return { rotulo: 'Aguardando link de pagamento', tom: 'espera', severidade: 'espera', entregueApesarDoErro: false, ehFalha: false }
  }

  if (status === 'suppressed') {
    return { rotulo: 'Não quis receber', tom: 'mudo', severidade: 'mudo', entregueApesarDoErro: false, ehFalha: false }
  }

  // Retidas pelo SmartFilter. Adiada por regra de horário sai sozinha quando o
  // horário chega; a que pede conferência espera alguém aprovar na aba do
  // SmartFilter (e vira erro se ninguém decidir em 24 h). Nenhuma é falha —
  // antes caíam em "Não identificado" e o gestor não entendia o que era.
  if (status === 'smartfilter_delayed') {
    return { rotulo: 'Adiada pelo SmartFilter', tom: 'espera', severidade: 'espera', entregueApesarDoErro: false, ehFalha: false }
  }

  if (status === 'smartfilter_pending_approval') {
    return { rotulo: 'Aguardando conferência', tom: 'espera', severidade: 'espera', entregueApesarDoErro: false, ehFalha: false }
  }

  // Cancelada pelo cliente no disparo em massa: o disparo foi cancelado antes
  // de ela sair. Não saiu e não é cobrada — e não é falha, foi decisão de quem
  // disparou.
  if (status === 'cancelada') {
    return { rotulo: 'Cancelada pelo cliente', tom: 'mudo', severidade: 'mudo', entregueApesarDoErro: false, ehFalha: false }
  }

  return { ...NAO_IDENTIFICADO }
}

const messageStatusLib = { getMessageStatus }

export default messageStatusLib
